import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpecializationRoutingModule } from './specialization-routing.module';
import { SpecializationListComponent } from './specialization-list/specialization-list.component';
import { SpecializationCreateComponent } from './specialization-create/specialization-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [SpecializationListComponent, SpecializationCreateComponent],
  imports: [
    CommonModule,
    SpecializationRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class SpecializationModule { }
